module.exports = __webpack_public_path__ + "static/media/strefa-ksero.c58804e4.svg";